import { html } from 'lit';

export const EdgelessEraserLightIcon = html`<svg
  width="44"
  height="60"
  viewBox="0 0 44 60"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  id="edgeless-eraser-icon"
>
  <g filter="url(#eraser-shadow)">
    <!-- Pink rubber block -->
    <path
      d="M12 6C12 4.89543 12.8954 4 14 4H24.5L32 11.5V36C32 37.1046 31.1046 38 30 38H14C12.8954 38 12 37.1046 12 36V6Z"
      fill="url(#pink-rubber)"
    />
    <!-- Sleek inner highlight on rubber -->
    <path
      d="M13 6C13 5.44772 13.4477 5 14 5H24L31 12V35C31 35.5523 30.5523 36 30 36H14C13.4477 36 13 35.5523 13 35V6Z"
      stroke="white"
      stroke-opacity="0.25"
      fill="none"
    />
    <!-- Sleeve wrapper - extended to height 60 to match pencil -->
    <path
      d="M11 16C11 14.8954 11.8954 14 13 14H31C32.1046 14 33 14.8954 33 16V52C33 53.1046 32.1046 54 31 54H13C11.8954 54 11 53.1046 11 52V16Z"
      fill="url(#sleeve-light)"
      stroke="#E3E2E4"
      stroke-width="1"
    />
    <!-- Elegant colored stripe on sleeve -->
    <path
      d="M11.5 24H32.5V28H11.5V24Z"
      fill="url(#stripe-gradient-light)"
    />
  </g>
  <defs>
    <filter id="eraser-shadow" x="7" y="2" width="30" height="60" filterUnits="userSpaceOnUse">
      <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#0f172a" flood-opacity="0.15" />
    </filter>
    <linearGradient id="pink-rubber" x1="12" y1="4" x2="32" y2="38" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#FF9AA6" />
      <stop offset="100%" stop-color="#FF6B7F" />
    </linearGradient>
    <linearGradient id="sleeve-light" x1="11" y1="14" x2="33" y2="54" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#FFFFFF" />
      <stop offset="100%" stop-color="#F1F3F5" />
    </linearGradient>
    <linearGradient id="stripe-gradient-light" x1="11.5" y1="24" x2="32.5" y2="28" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#38bdf8" />
      <stop offset="100%" stop-color="#0284c7" />
    </linearGradient>
  </defs>
</svg>`;

export const EdgelessEraserDarkIcon = html`<svg
  width="44"
  height="60"
  viewBox="0 0 44 60"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  id="edgeless-eraser-icon"
>
  <g filter="url(#eraser-shadow-dark)">
    <!-- Pink rubber block -->
    <path
      d="M12 6C12 4.89543 12.8954 4 14 4H24.5L32 11.5V36C32 37.1046 31.1046 38 30 38H14C12.8954 38 12 37.1046 12 36V6Z"
      fill="url(#pink-rubber-dark)"
    />
    <!-- Sleek inner highlight on rubber -->
    <path
      d="M13 6C13 5.44772 13.4477 5 14 5H24L31 12V35C31 35.5523 30.5523 36 30 36H14C13.4477 36 13 35.5523 13 35V6Z"
      stroke="white"
      stroke-opacity="0.2"
      fill="none"
    />
    <!-- Sleeve wrapper - extended to height 60 to match pencil -->
    <path
      d="M11 16C11 14.8954 11.8954 14 13 14H31C32.1046 14 33 14.8954 33 16V52C33 53.1046 32.1046 54 31 54H13C11.8954 54 11 53.1046 11 52V16Z"
      fill="url(#sleeve-dark)"
      stroke="#334155"
      stroke-width="1"
    />
    <!-- Elegant colored stripe on sleeve -->
    <path
      d="M11.5 24H32.5V28H11.5V24Z"
      fill="url(#stripe-gradient-dark)"
    />
  </g>
  <defs>
    <filter id="eraser-shadow-dark" x="7" y="2" width="30" height="60" filterUnits="userSpaceOnUse">
      <feDropShadow dx="0" dy="2" stdDeviation="2.5" flood-color="#000000" flood-opacity="0.5" />
    </filter>
    <linearGradient id="pink-rubber-dark" x1="12" y1="4" x2="32" y2="38" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#FFA4B0" />
      <stop offset="100%" stop-color="#FF5A72" />
    </linearGradient>
    <linearGradient id="sleeve-dark" x1="11" y1="14" x2="33" y2="54" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#1E293B" />
      <stop offset="100%" stop-color="#0F172A" />
    </linearGradient>
    <linearGradient id="stripe-gradient-dark" x1="11.5" y1="24" x2="32.5" y2="28" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#38bdf8" />
      <stop offset="100%" stop-color="#0ea5e9" />
    </linearGradient>
  </defs>
</svg>`;
